import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export const UploadProgress = ({ uploadProgress = 0 }) => {
  const { t } = useTranslation();

  return (
    <div className="row progress no-gutters">
      <div className="row justify-content-start progress-bar no-gutters">
        <div className="state" style={{ width: uploadProgress + '%' }} />
      </div>

      <div className="row justify-content-center align-content-center no-gutters mask">
        <span className="text">{t('uploaded', { uploadProgress })}</span>
      </div>
    </div>
  );
};

UploadProgress.propTypes = {
  uploadProgress: PropTypes.number,
};
